<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <collection-editor
        v-model="form"
        :image-url="imageUrl"
        :disabled="isEditorDisabled"
        @isLoading="handleIsLoading"
      ></collection-editor>
      <div v-if="!isEditorDisabled" class="d-flex justify-content-between">
        <sc-button :disabled="isLoading" variant="danger" @click="handleClickRemove">ลบ</sc-button>
        <sc-button :disabled="isLoading" variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { MessageBox } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { uploadPublicImage } from "@/god";
import CollectionEditor from "../components/CollectionEditor";

export default {
  name: "CollectionDetailPage",
  components: {
    PageWrapper,
    ScButton,
    CollectionEditor,
  },
  data() {
    const title = "รายละเอียดแพ็กเกจใหญ่";
    const form = {
      name: "",
      packages: [],
      imageFile: null,
    };

    const imageUrl = null;

    return {
      title,
      form,
      imageUrl,
      isLoading: true,
    };
  },
  computed: {
    isEditorDisabled() {
      return this.$isCallCenter;
    },
  },
  watch: {
    form(form, oldForm) {
      if (this.form.imageFile === oldForm.imageFile) {
        return;
      }

      this.imageUrl = URL.createObjectURL(this.form.imageFile);
    },
  },
  created() {
    this.setup();
  },
  methods: {
    getRouteCollectionId() {
      const { id } = this.$route.params;
      if (!id) {
        this.$message.error("ไม่พบรหัสแพ็กเกจใหญ่");
        return null;
      }

      return id;
    },
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupForm();
    },

    async setupForm() {
      const data = await this.fetchData();
      if (!data) {
        this.isLoading = false;
        return;
      }

      const { name, packages, image: imageUrl } = data;

      this.form = {
        name,
        packages: packages.map((p) => ({
          id: p.id,
          name: p.name,
          subpackages: p.subpackages,
          target: p.target,
          price: p.price,
          billingCycle: p.billing_cycle,
          detail: p.detail,
          serviceCount: (p.service_ids || []).length,
          projectCount: (p.project_ids || []).length,
          imageUrl: p.image,
        })),
        imageFile: null,
      };
      this.imageUrl = imageUrl;

      this.isLoading = false;
    },
    async fetchData() {
      const id = this.getRouteCollectionId();
      if (!id) {
        return null;
      }

      const response = await baanRueJaiClient.admin.subscriptions.collections.get(
        id
      );

      return response.data.result;
    },
    async handleClickSave() {
      try {
        await this.updateCollection();
        this.$router.push({ name: "CollectionListPage" });
      } catch {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async updateCollection() {
      const { name, packages, imageFile } = this.form;

      if (!name) {
        this.$message.error("กรุณากรอกชื่อ หรือ โปรดรอให้ระบบดึงข้อมูล");
        return;
      }

      const id = this.getRouteCollectionId();
      if (!id) {
        return;
      }

      const packageIds = packages.map((pkg) => pkg.id);
      const type = "NORMAL";
      const description = "";

      const params = {
        name,
        packageIds,
        type,
        description,
      };

      if (imageFile) {
        params.image = await uploadPublicImage(imageFile);
      }

      await baanRueJaiClient.admin.subscriptions.collections.put(
        id,
        params
      );
    },
    async handleClickRemove() {
      try {
        await MessageBox.confirm("ยืนยันการลบ", { confirmButtonText: "ตกลง", cancelButtonText: "ยกเลิก" });
      } catch {
        return;
      }

      try {
        await this.removeCollection();
        this.$router.push({ name: "CollectionListPage" });
      } catch {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async removeCollection() {
      const id = this.getRouteCollectionId();
      if (!id) {
        return;
      }

      await baanRueJaiClient.admin.subscriptions.collections.delete(id);
    },
    handleIsLoading(isLoading) {
      this.isLoading = isLoading;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>
